module.exports = __webpack_public_path__ + "media/images/pages/bg_area_12-f434a9f56cb3e4087c42044902524a06.png";